import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { modifyScheduler, getDBSelectedDaysPeriod } from "./logsRetentionService";

export default function DBRetentionSection() {

  const { setPopup } = useContext(PopupContext);
  const [days, setDaysPeriod] = useState('0');


  // const setPeriod = false;
  const isStartDisabled = false;
  //const [selectedDate, setSelectedDate] = useState(new Date());


  const fetchData = async () => {
    try {
      let x = await getDBSelectedDaysPeriod();
      setDaysPeriod(x);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetDBRetentionPeriodClick = event => {
    showInfoToast('Setting Database Retention Period', 'Database Retention Period');
    // setPeriod(true);

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR DB Retention Period',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      modifyScheduler(days);
    };
  };



  //   const DatePickerInput = forwardRef(({ value, onClick }, ref) => (

  //     <button className="btn oct_btn-date-picker " onClick={onClick} ref={ref}>
  //         {value}
  //     </button>
  // ));

  const changeDaysPeriod = (value) => { setDaysPeriod(value); }

  return (
    <>
      <p className="oct_settings-description">
        SysLog Data logged before the Selected Days Period will be wiped permanently.
      </p>

      <div className="oct_settings-form-grid">
        <div className="oct_settings-field">
          <label className="oct_settings-label">Retention Period</label>
          <input
            className="oct_settings-input-v2"
            type="number"
            value={days}
            onChange={event => changeDaysPeriod(event.target.value)}
          />
        </div>
        <div className="oct_settings-field">
          <label className="oct_settings-label">Unit</label>
          <select className="oct_select-v2" disabled>
            <option value="Days">Days</option>
          </select>
        </div>
      </div>

      <button
        className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
        onClick={onSetDBRetentionPeriodClick}
      >
        Save Syslog Data Retention Period
      </button>
    </>
  );
}
